import React, { useCallback } from "react";
import Styled from "./progressBar.style";
export default function ProgressBar(props) {
    const { progressBarRef, mediaRef } = props;
    const handleProgressChange = useCallback(() => {
        if ((mediaRef === null || mediaRef === void 0 ? void 0 : mediaRef.current) && (progressBarRef === null || progressBarRef === void 0 ? void 0 : progressBarRef.current)) {
            mediaRef.current.currentTime = Number(progressBarRef.current.value);
        }
    }, [mediaRef, progressBarRef]);
    return (React.createElement("div", { className: "w-100" },
        React.createElement(Styled.ProgressScale, { ref: progressBarRef, onChange: handleProgressChange, defaultValue: "0" })));
}
